(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(scope = document) {
    scope.querySelectorAll('[data-lm-tabs]').forEach(section => {
      if (section.dataset.lmReady) return;
      section.dataset.lmReady = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-lm-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-lm-panel]'));
      const list = section.querySelector('[data-lm-tablist]');
      const controls = section.querySelector('[data-lm-slider-controls]');
      if (!tabs.length || !panels.length) return;
      function activeTrack() {
        return panels.find(panel => !panel.hidden)?.querySelector('[data-lm-track]');
      }
      function updateControls() {
        if (!controls) return;
        const track = activeTrack();
        const overflows = track && track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflows;
        controls.querySelector('[data-lm-prev]').disabled = !overflows || track.scrollLeft <= 2;
        controls.querySelector('[data-lm-next]').disabled = !overflows || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function select(id, focus = false) {
        tabs.forEach(tab => {
          const active = tab.dataset.lmTab === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.lmPanel !== id; });
        requestAnimationFrame(updateControls);
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.lmTab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); select(tabs[target].dataset.lmTab, true); }
        });
      });
      controls?.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        const track = activeTrack();
        if (track) track.scrollBy({ left: (button.hasAttribute('data-lm-prev') ? -1 : 1) * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }));
      panels.forEach(panel => panel.querySelector('[data-lm-track]')?.addEventListener('scroll', updateControls, { passive: true }));
      if (window.ResizeObserver) { const observer = new ResizeObserver(updateControls); observer.observe(section); section._lmObserver = observer; }
      list.hidden = tabs.length < 2;
      section.classList.add('lm-tabs-ready');
      select(tabs[0].dataset.lmTab);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-lm-tabs]').forEach(section => section._lmObserver?.disconnect()));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-lm-panel]');
    if (panel) panel.closest('[data-lm-tabs]')?.querySelector(`[data-lm-tab="${panel.dataset.lmPanel}"]`)?.click();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-lm-menu][open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-lm-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  let refreshing = false;
  async function refreshCart() {
    if (refreshing) return;
    refreshing = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const cart = await response.json();
        document.querySelectorAll('[data-lm-cart-count]').forEach(count => { count.textContent = cart.item_count; });
      }
    } catch (_) { /* Keep the server-rendered count if a refresh is unavailable. */ }
    finally { refreshing = false; }
  }
  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('cart:count:update', refreshCart);
  window.addEventListener('pageshow', refreshCart);
})();
